module.exports = __webpack_public_path__ + "img/free-trial-top.abd13a9e.png";